import { useOfficeTranslation } from "i18n/OfficeTranslation";
import { DashboardWidgetType } from "models/Dashboard";
import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { dashboardWidgetRegistry } from "./widgetRegistry";

interface Props {
    open: boolean;
    onAdd: (type: DashboardWidgetType) => void;
    onClose: () => void;
}

const DashboardAddWidgetModal: React.FC<Props> = ({ open, onAdd, onClose }) => {
    const { t } = useOfficeTranslation();
    return <Modal isOpen={open} toggle={onClose} size="lg" scrollable>
        <ModalHeader toggle={onClose}>{t("dashboard.editor.addWidget")}</ModalHeader>
        <ModalBody>
            <div className="dashboard-widget-catalogue">
                {dashboardWidgetRegistry.map(definition => <div className="dashboard-widget-catalogue-item" key={definition.type}>
                    <div className="dashboard-widget-catalogue-icon"><i className={`mdi ${definition.icon}`} aria-hidden="true" /></div>
                    <div className="min-w-0 flex-grow-1">
                        <h6 className="mb-1">{t(definition.titleKey)}</h6>
                        <p className="text-muted mb-0">{t(definition.descriptionKey)}</p>
                    </div>
                    <Button color="primary" outline type="button" onClick={() => onAdd(definition.type)}>
                        {t("common.add")}
                    </Button>
                </div>)}
            </div>
        </ModalBody>
        <ModalFooter><Button color="light" type="button" onClick={onClose}>{t("common.close")}</Button></ModalFooter>
    </Modal>;
};

export default DashboardAddWidgetModal;
